import React, { useContext, useState } from "react";
import { APIContext } from "../../../contexts/APIContext";

export default function CleanDevice({ primaryColor }) {
  const [serial, setSerial] = useState("");
  const [response, setResponse] = useState(null); // puede contener message o error
  const [loading, setLoading] = useState(false);
  const { postCleanDevice } = useContext(APIContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse(null);

    try {
      const res = await postCleanDevice(serial);

      if (res.error) {
        setResponse({ type: "error", text: res.error });
      } else {
        setResponse({ type: "success", text: res.message });
      }
    } catch (error) {
      console.error("Error cleaning device:", error);
      setResponse({
        type: "error",
        text: "An unexpected error occurred while cleaning the device.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow">
        <div className="card-body">
          <form
            onSubmit={handleSubmit}
            className="form-inline d-flex justify-content-center"
          >
            <div className="form-group mb-2 mr-2 w-50">
              <input
                type="text"
                className="form-control w-100"
                value={serial}
                onChange={(e) => setSerial(e.target.value)}
                placeholder="Enter serial"
              />
            </div>
            <button
              type="submit"
              style={{
                backgroundColor: primaryColor,
                borderColor: primaryColor,
              }}
              className="btn btn-danger mb-2"
              disabled={loading || !serial}
            >
              {loading ? "Processing..." : "Clean"}
            </button>
          </form>

          {response && (
            <div
              className={`alert mt-3 text-center ${
                response.type === "success" ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              <strong>{response.text}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
